import {useEffect,useState} from 'react'
import {MessageCircle,ChevronRight,Bell} from 'lucide-react'
import {forumEnabled} from './forumApi'
import {getForumCopy} from './forumCopy'
import {useForumUnreadSummary} from './forumUnread'
import './ForumScreen.css'
import './ForumEntry.css'

const unreadCopy={
  fr:count=>`${count} ${count===1?'message non lu':'messages non lus'} dans le forum`,
  de:count=>`${count} ${count===1?'ungelesene Nachricht':'ungelesene Nachrichten'} im Forum`,
  it:count=>`${count} ${count===1?'messaggio non letto':'messaggi non letti'} nel forum`,
  en:count=>`${count} unread ${count===1?'message':'messages'} in the forum`,
}
export default function ForumEntry({lang='fr',onOpen,userId,isActive=true}) {
  const copy=getForumCopy(lang)
  const summary=useForumUnreadSummary({userId,language:lang,isActive})
  const [pageVisible,setPageVisible]=useState(()=>!document.hidden)
  useEffect(()=>{
    const changed=()=>setPageVisible(!document.hidden)
    document.addEventListener('visibilitychange',changed)
    return()=>document.removeEventListener('visibilitychange',changed)
  },[])
  const count=summary.enabled?summary.count:0
  const label=count>0?`${copy.title} — ${(unreadCopy[lang]||unreadCopy.fr)(count)} — ${copy.spaces}`:undefined
  if(!forumEnabled())return null
  return <button type="button" className="hb-forum-entry" onClick={onOpen} aria-label={label}><MessageCircle size={28} aria-hidden="true"/><span><span className="hb-forum-entry-heading"><strong>{copy.title}</strong><span className="hb-forum-entry-bell" data-has-unread={count>0} data-motion-paused={!isActive||!pageVisible} aria-hidden="true"><Bell size={23}/>{count>0&&<span className="hb-forum-entry-unread">{count>99?'99+':count}</span>}</span></span><small>{copy.spaces}</small></span><ChevronRight size={20} aria-hidden="true"/></button>
}
